import signalRService from "../signalRService";
import { getStepName } from "./stepMappings";

class UserNavigationTracker {
  constructor() {
    this.isActive = false;
    this.userId = null;
    this.sessionId = null;
    this.tipoCliente = null;
    this.currentStep = null;
    this.currentView = null;
    this.lastEventTime = null;
    this.throttleMs = 1000;
  }

  startTracking(userId, tipoCliente, sessionId) {
    this.isActive = true;
    this.userId = userId;
    this.tipoCliente = tipoCliente;
    this.sessionId = sessionId || `session_${Date.now()}_${userId}`;
  }

  stopTracking() {
    this.isActive = false;
  }

  trackStepChange(stepNumber, context = {}) {
    if (!this.isActive) {
      console.warn("⚠️ NavigationTracker: Não ativo - ignorando");
      return;
    }

    const now = Date.now();

    if (
      this.currentStep === stepNumber &&
      this.lastEventTime &&
      now - this.lastEventTime < this.throttleMs
    ) {
      return;
    }

    const stepName = getStepName(this.tipoCliente, stepNumber);
    const previousStep = this.currentStep;

    const eventData = {
      userId: this.userId,
      sessionId: this.sessionId,
      tipoCliente: this.tipoCliente,
      viewType: context.view || this.currentView || "unknown",
      stepNumber: stepNumber,
      stepName: stepName,
      previousStep: previousStep,
      timestamp: new Date().toISOString(),
      metadata: {
        isEditing: context.editing || false,
        renovacaoCadastral: context.renovacao || false,
        completedSteps: context.completedSteps || [],
      },
    };

    this.sendNavigationEvent(eventData);

    this.currentStep = stepNumber;
    this.lastEventTime = now;
  }

  trackViewChange(viewName) {
    this.currentView = viewName;
  }

  async trackCadastroCompleted(context = {}) {
    if (!this.isActive) {
      console.warn("⚠️ NavigationTracker: Não ativo - ignorando conclusão");
      return;
    }

    const eventData = {
      userId: this.userId,
      sessionId: this.sessionId,
      tipoCliente: this.tipoCliente,
      eventType: "cadastro_completed",
      timestamp: new Date().toISOString(),
      metadata: {
        renovacaoCadastral: context.renovacao || false,
        completedSteps: context.completedSteps || [],
      },
    };

    try {
      await signalRService.notifyCadastroCompleted(eventData);
      this.stopTracking();
    } catch (error) {
      console.error(
        "❌ NavigationTracker: Erro ao notificar conclusão:",
        error,
      );
    }
  }

  async sendNavigationEvent(eventData) {
    try {
      await signalRService.trackUserNavigation(eventData);
    } catch (error) {
      console.error("❌ NavigationTracker: Erro ao enviar evento:", error);
    }
  }
}

export default new UserNavigationTracker();
